import lang from "@/views/modules/EmailTemplates/language/en";
//import Editor from '@tinymce/tinymce-vue';
export default {
    name: "detail-email-templates",
    components: {
//        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            example: {},
            lang:[],
        }
    },
    mounted() {
        this.getBudgethead();
        this.lang = lang;
    },
    methods: {
        saveBudgethead() {
            const self = this;
            self.loading = true;
            axios.put('api/modules/emailtemplates/' + self.$route.params.id, self.example).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getBudgethead() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/emailtemplates/' + self.$route.params.id).then(function (response) {
                self.example = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        
    }
}